import {HttpResponse} from 'msw';

import type {CheckoutProfileMissing} from '../types';

export type CheckoutProfileMockRefusal = {
  code: string;
  path?: string;
  message: string;
  checkoutProfileId?: string;
  missing?: CheckoutProfileMissing[];
  rules?: {id: string; name: string; priority: number}[];
};

export const checkoutProfileMockRefusal = (refusals: CheckoutProfileMockRefusal[], status = 400) =>
  HttpResponse.json(
    {
      errors: refusals.map((refusal) => ({
        ...refusal,
        path: (refusal.path ?? '').replace(/\.(\d+)(?=\.|$)/g, '[$1]'),
        ...(refusal.rules
          ? {rules: refusal.rules.map(({id, name, priority}) => ({id, name, priority}))}
          : {}),
      })),
    },
    {status}
  );
